import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReportUsageContext } from 'src/pages/reportUsage';
import ProcedureViewContainer from './ProcedureViewContainer';
import {
    setProcedureData,
    setRetractorUsedOtherField,
    setReportUsageFormObject,
    validateMazorCodeRequest,
    setProcedureInfo,
    setMazorCaseCoverageValue,
    setStealthCaseCoverageValue,
} from '../../redux/action/actionCreators';
import {
    VALIDATE_MAZOR_CODE_RESPONSE,
    SET_ADVANCE_ENERGY_DATA,
    VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
} from '../../redux/action/types';
import {
    getModifiedPhysicianFinderData,
    getModifiedDeformityCorrectionData,
    getModifiedAdditionalProcedureData,
    getModifiedPhysicianFinderDataOnCheckboxSelection,
    getModifiedBiologicsUsedDataOnCheckboxSelection,
    getModifiedRetractorUsedOnCheckboxSelection,
} from '../dataTransformationUtil';
import ReportPayment from '../../record/components/reportPayment/reportPayment';
import {
    checkIfValidProcedureData,
    createProcedureDraftOrderObject,
} from '../../utils/eventHandlerUtil';
import { modifyDraftProcedureDataResponse } from '../../utils/dataModificaionUtil';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import {
    pageNames,
    MANDATORY,
    VISIBLE,
    REPORT_USAGE,
} from 'src/constants/appConstants';
import {
    getAdditionalTextareaLimit,
    isIOSiPhoneDevice,
    procedureFilterData,
} from 'src/utils/util';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { useTranslation } from 'react-i18next';
import { getDropdownValues } from 'src/pages/scheduleSurgery/redux/actions';
import { getConfigurations, setPediatricCheck } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ProcedureScreen = ({
    procedureInfoData,
    setProcedureInfoData,
    // isErrorFoundInProcedure,
    // isErrorFoundInFirstLevel,
    setshowReportPayment,
    showReportPayment,
    proceduresList,
    reportPaymentGridData,
    setReportPaymentGridData,
    selectedPhysicianData,
    setSelectedPhysicianData,
    dropDownValue,
    setDropDownValue,
    myCaseResourceType,
    rpInitialLoad,
    setRpInitialLoad,
    progressBarClicked,
    vendorCaseErrorRedirection,
    onFlagChange,
    isPriceOverride,
    setPriceOverride,
    isRPPriceOverride,
    setRPPriceOverride,
    setRPPriceOverrideData,
    priceOverrideReason,
    setPriceOverrideReason,
    shipAddress,
    setShipAddress,
    navigateToSpecifiedRPScreen,
    pricingNotes,
    setPricingNotes,
    currentActivity,
    countryCode,
    setIsReportPaymentScreen,
    selectedMazorCaseCoverage,
    setSelectedMazorCaseCoverage,
    setMazorCaseCoverageInputValue,
    mazorCaseCoverageInputValue,
    setViewSurgeryNotes,
    downArrow = false,
    setAdvancedEnergyCheck,
    advancedEnergyCheck,
    setshowBiologisDetails,
    showBiologisDetails,
    isDraft,
    setDraft,
    pediatricDraftValue,
    setPediatricDraftValue,
    setStealthAxisCaseCoverageInputValue,
    stealthAxisCaseCoverageInputValue,
    setSelectedStealthAxisCaseCoverage,
    selectedStealthAxisCaseCoverage,
    setPriceOverrideTableData,
    priceOverrideTableData,
    physicianFieldText,
    setPhysicianFieldText,
    physicianTextBoxType,
    setPhysicianTextBoxType,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        usageDetails,
        reportUsageFormObj,
        setReportUsageFormObj,
        footerButtonStatuses,
        setFooterButtonStatuses,
    } = useContext(ReportUsageContext);
    // const countryCode = useSelector(
    //     (state) => state.loginReducer.hybrisUserDetails.countryCode
    // );
    const submit = t('noUsageToReport.submitButton');

    const procedureInfoDetails = useSelector(
        (state) => state.reportUsageRootReducer.procedureData
    );

    const [mazorxChecked, setMazorxChecked] = useState(false);
    const [advanceEnergyProduct, setAdvanceEnergyProduct] = useState([]);
    const [physicianInputValue, setPhysicianInputValue] = useState('');
    const [mazorRoboticsCode, setMazorRoboticsCode] = useState('');
    const [advEnergyCode, setAdvEnergyCode] = useState(false);
    const [stealthAxisChecked, setStealthAxisChecked] = useState(false);
    const [stealthAxisCode, setStealthAxisCode] = useState('');
    const [stealthAxisAutoPilot, setStealthAxisAutoPilot] = useState(null);
    const [stealthAxisLiveAlign, setStealthAxisLiveAlign] = useState(null);
    const [stealthAxisCodeError, setStealthAxisCodeError] = useState('');

    const charCountLimit = 40;
    const [textAreaCharLimit, setTextAreaCharLimit] = useState(charCountLimit);

    const validateMazorCodeRes = useSelector(
        (state) => state.reportUsageRootReducer.validateMazorCodeRes
    );
    const advanceEnergyRes = useSelector(
        (state) => state.reportUsageRootReducer.advanceEnergyData
    );

    const isErrorFoundInFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInFirstLevel
    );
    const isErrorFoundInProcedure = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInProcedure
    );
    const reportUsageObject = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );
    const { salesOrg, pediatricCheck, dropdownData, physicianDropdownValue } =
        useSelector((state) => ({
            salesOrg: state.loginReducer.salesOrg,
            pediatricCheck: state.loginReducer.pediatricCheck,
            dropdownData: state.reportUsageRootReducer?.dropdownData,
            physicianDropdownValue:
                state.reportUsageRootReducer?.physicianDropdownValue,
        }));

    const { physicianName } = useSelector((state) => ({
        physicianName:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.physicianName,
    }));
    const {
        physicianDropdownZGReportUsageVisibility,
        physicianDropdownZGReportUsageMandatory,
        procedureTypeUsageMandatoryRule,
        procedureTypeUsageVisibility,
        pediatricSurgery,
        pediatricSurgeryMandatory,
        priceOverrideReasonMandatoryUsage,
        priceOverrideReasonVisibilityUsage,
        priceOverrideCommentsMandatoryUsage,
        priceOverrideCommentsVisibilityUsage,
        reportUsageStealthLiveAlignVisibility,
        reportUsageStealthAutoPilotVisibility,
        physicianTextUsageVisibility,
        physicianTextUsageMandatory,
    } = useSelector((state) => state.loginReducer);

    useEffectWithErrorLogging(() => {
        if (physicianDropdownZGReportUsageVisibility === VISIBLE) {
            setPhysicianInputValue(
                physicianDropdownValue?.physicianDisplayName
            );
            setSelectedPhysicianData(physicianDropdownValue);
        }
    }, [currentActivity]);
    const orderStatusDescription = useSelector(
        (state) =>
            state?.orderSummaryReducer?.orderBasicDetails
                ?.orderStatusDescription
    );
    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );
    const [allSelected, setAllSelected] = useState(false);
    const [checkBoxSelectedIndex, setCheckBoxSelectedIndex] = useState('');
    const [selectedCheckBox, setSelectedCheckBox] = useState([]);
    const [isDisabledPediatric, setDisabledPediatric] = useState(false);
    const [isPediatricSurgery, setPediatricSurgery] = useState('');

    useDynatracePageName(pageNames.reportUsageProcedure);

    const procedureData = useSelector(
        (state) => state.reportUsageRootReducer.procedureData
    );

    const procedurePageVisibility = useSelector(
        (state) => state.loginReducer.procedurePageVisibility
    );
    const priceOverrideReportUsageVisibility = useSelector(
        (state) => state.loginReducer.priceOverrideReportUsageVisibility
    );
    const usageProcedureData = useSelector(
        (state) =>
            state.reportUsageRootReducer?.usageDetails?.procedure
                ?.additionProcedure
    );
    const procedureDataPhysician = useSelector(
        (state) => state.loginReducer?.procedureDataPhysician
    );
    const retractorUsedOtherFieldValue = useSelector(
        (state) => state.reportUsageRootReducer.retractorUsedOtherFieldData
    );
    // const isErrorFoundInProcedureData = useSelector(
    //     (state) => state.reportUsageRootReducer.isErrorFoundInProcedure
    // );
    const totalLevelsNumber = useSelector(
        (state) => state.reportUsageRootReducer.totalLevelsNumber
    );
    const uivArray = useSelector(
        (state) => state.reportUsageRootReducer.uivArray
    );
    const livArray = useSelector(
        (state) => state.reportUsageRootReducer.livArray
    );
    const showProcedureDropdown = procedureTypeUsageVisibility === VISIBLE;
    const procedureDataPhysicianVisibility =
        physicianDropdownZGReportUsageVisibility === VISIBLE ||
        procedureDataPhysician === VISIBLE;
    const pediatricMandatoryRule = pediatricSurgeryMandatory === MANDATORY;
    const pediatricSurgeryVisibility =
        procedureTypeUsageVisibility === VISIBLE
            ? pediatricSurgery === VISIBLE
            : false;
    useEffectWithErrorLogging(() => {
        if (
            advanceEnergyRes &&
            procedureInfoDetails?.additionalProcedure &&
            procedureInfoDetails.additionalProcedure[0] !==
                'ADDITIONAL_PROCEDURE_DATA'
        ) {
            let arCh = Object.keys(advanceEnergyRes).filter(
                (it) => advanceEnergyRes[it] === true
            );
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                arCh.length > 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                setAdvancedEnergyCheck(true);
            }
        }
    }, []);
    useEffectWithErrorLogging(() => {
        setPediatricSurgery(pediatricCheck);
    }, [pediatricCheck]);
    useEffectWithErrorLogging(() => {
        if (
            pediatricSurgeryVisibility &&
            dropdownData?.procedures?.defaultYesPediatricProcedures &&
            reportUsageObject?.procedureCode &&
            dropdownData?.procedures?.defaultYesPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageObject?.procedureCode.trim())
        ) {
            !pediatricDraftValue && dispatch(setPediatricCheck(true));
            pediatricDraftValue && setPediatricDraftValue(false);
        } else if (
            pediatricSurgeryVisibility &&
            dropdownData?.procedures?.defaultNoPediatricProcedures &&
            reportUsageObject?.procedureCode &&
            dropdownData?.procedures?.defaultNoPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageObject?.procedureCode.trim())
        ) {
            !pediatricDraftValue && dispatch(setPediatricCheck(false));
            pediatricDraftValue && setPediatricDraftValue(false);
        } else {
            setDisabledPediatric(false);
            !pediatricDraftValue &&
                pediatricCheck === '' &&
                dispatch(setPediatricCheck(''));
        }
    }, [
        reportUsageObject?.procedureCode,
        dropdownData?.procedures?.defaultYesPediatricProcedures,
        dropdownData?.procedures?.defaultNoPediatricProcedures,
    ]);

    useEffectWithErrorLogging(() => {
        if (
            advanceEnergyRes &&
            procedureInfoDetails?.additionalProcedure &&
            procedureInfoDetails.additionalProcedure[0] !==
                'ADDITIONAL_PROCEDURE_DATA'
        ) {
            let arCh = Object.keys(advanceEnergyRes).filter(
                (it) => advanceEnergyRes[it] === true
            );
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                arCh.length > 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                setAdvancedEnergyCheck(true);
            }
        }
    }, [advanceEnergyRes]);

    useEffectWithErrorLogging(() => {
        if (countryCode !== COUNTRY_CODE_JAPN) {
            if (Object.keys(procedureData).length > 0) {
                const draftProcedureData = modifyDraftProcedureDataResponse(
                    JSON.parse(JSON.stringify(procedureData))
                );
                const medtronicOrCompetitve =
                    draftProcedureData?.biologicsUsed?.filter(
                        (x) => x.isSelected && x.code === '02'
                    );
                if (medtronicOrCompetitve?.length > 0) {
                    setshowBiologisDetails(true);
                } else {
                    setshowBiologisDetails(false);
                }
            }
        } else {
            if (
                Object.keys(procedureData).length > 0 &&
                procedurePageVisibility
            ) {
                const draftProcedureData = modifyDraftProcedureDataResponse(
                    JSON.parse(JSON.stringify(procedureData))
                );
                const medtronicOrCompetitve =
                    draftProcedureData?.biologicsUsed?.filter(
                        (x) => x.isSelected && x.code === '02'
                    );
                if (medtronicOrCompetitve?.length > 0) {
                    setshowBiologisDetails(true);
                } else {
                    setshowBiologisDetails(false);
                }
            }
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (
            procedureInfoDetails &&
            procedureInfoDetails?.additionalProcedure &&
            procedureInfoDetails?.additionalProcedure[0] !==
                'ADDITIONAL_PROCEDURE_DATA'
        ) {
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergyIndex = additionalProcedure.findIndex(
                (item) => item.description === 'Advanced Energy'
            );

            if (advancedEnergyIndex !== -1) {
                const advancedEnergy = additionalProcedure[advancedEnergyIndex];
                let energyProdArr = [];

                const products = advancedEnergy?.advancedEnergyProduct;

                if (!advancedEnergy.isSelected) {
                    // Get unselected products
                    if (products && typeof products === 'object') {
                        Object.keys(products).forEach((key) => {
                            if (products[key]) {
                                energyProdArr.push({
                                    description: key,
                                    isSelected: false,
                                });
                            }
                        });
                    }
                } else if (products && typeof products === 'object') {
                    // Get selected state from products
                    Object.keys(products).forEach((key) => {
                        energyProdArr.push({
                            description: key,
                            isSelected: products[key],
                        });
                    });
                }

                setAdvanceEnergyProduct(energyProdArr);
            }

            // Handle usageProcedureData & procedureData
            if (
                usageProcedureData?.advancedEnergyProduct &&
                Object.keys(usageProcedureData?.advancedEnergyProduct).length >
                    0 &&
                Object.keys(procedureData).length > 0
            ) {
                const advInd = procedureData?.additionalProcedure?.findIndex(
                    (item) => item.description === 'Advanced Energy'
                );

                if (
                    advInd !== -1 &&
                    procedureData?.additionalProcedure?.[advInd]?.isSelected
                ) {
                    setAdvancedEnergyCheck(true);
                }

                const productData =
                    procedureData?.additionalProcedure?.[advInd]
                        ?.advancedEnergyProduct;

                const prArr =
                    productData && typeof productData === 'object'
                        ? Object.keys(productData)
                        : [];

                let energyProdArr = prArr.map((pr) => ({
                    description: pr,
                    isSelected: productData[pr],
                }));

                if (productData) {
                    dispatch({
                        type: SET_ADVANCE_ENERGY_DATA,
                        payload: productData,
                    });
                    setAdvanceEnergyProduct(energyProdArr);
                }
            }
        }
    }, [procedureInfoDetails]);

    useEffectWithErrorLogging(() => {
        let energyProdArr = [];
        if (
            Object.keys(procedureData).length > 0 &&
            orderStatusDescription !== undefined &&
            orderStatusDescription ===
                t('orders.orderStatuses.draftNotSubmitted') &&
            Object.keys(procedureData?.additionalProcedure).length > 0
        ) {
            const additionalProcedure = procedureData?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                advancedEnergy >= 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                let advEnergyProducts = Object.keys(
                    additionalProcedure[advancedEnergy].advancedEnergyProduct
                );
                advEnergyProducts &&
                    advEnergyProducts.map((pr) => {
                        let obj = {
                            description: pr,
                            isSelected:
                                additionalProcedure[advancedEnergy]
                                    .advancedEnergyProduct[pr],
                        };
                        energyProdArr.push(obj);
                    });
                setAdvanceEnergyProduct(energyProdArr);
            }
            if (
                usageProcedureData?.advancedEnergyProduct &&
                Object.keys(usageProcedureData?.advancedEnergyProduct).length >
                    0 &&
                Object.keys(procedureData).length > 0
            ) {
                energyProdArr = [];
                let advInd = procedureData?.additionalProcedure?.findIndex(
                    (it) => it.description === 'Advanced Energy'
                );
                if (
                    advInd &&
                    advInd >= 0 &&
                    procedureData?.additionalProcedure[advInd]?.isSelected
                ) {
                    setAdvancedEnergyCheck(true);
                }
            }
        }
    }, [procedureData]);

    useEffectWithErrorLogging(() => {
        if (
            usageDetails?.procedure &&
            Object.keys(usageDetails.procedure).length > 0 &&
            Object.keys(procedureData).length > 0
        ) {
            const draftProcedureData = modifyDraftProcedureDataResponse(
                JSON.parse(JSON.stringify(procedureData)),
                usageDetails.procedure
            );
            const medtronicOrCompetitve =
                draftProcedureData?.biologicsUsed?.filter(
                    (x) => x.isSelected && x.code === '02'
                );
            if (medtronicOrCompetitve?.length > 0) {
                setshowBiologisDetails(true);
            } else {
                setshowBiologisDetails(false);
            }
            setProcedureInfoData(draftProcedureData);
            dispatch(setProcedureData(draftProcedureData));
        }
    }, [usageDetails]);

    useEffectWithErrorLogging(() => {
        if (
            procedureInfoData &&
            procedureInfoData.additionalProcedure &&
            procedureInfoData.additionalProcedure[0] !==
                'ADDITIONAL_PROCEDURE_DATA'
        ) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const mazorxIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'MazorX Robot Used'
            );
            if (
                mazorxIdx >= 0 &&
                additionalProcedureData[mazorxIdx] &&
                additionalProcedureData[mazorxIdx].isSelected
            ) {
                setMazorxChecked(true);
                if (additionalProcedureData[mazorxIdx].mazorKitCode) {
                    setMazorRoboticsCode(
                        additionalProcedureData[mazorxIdx].mazorKitCode
                    );
                    if (
                        validateMazorCodeRes?.statusCode !== '10723' &&
                        usageDetails.procedure?.additionProcedure
                            ?.isMazorXRoboticsUsed &&
                        usageDetails.procedure?.additionProcedure
                            ?.mazorKitCode &&
                        usageDetails.procedure?.additionProcedure
                            ?.mazorKitCode ===
                            additionalProcedureData[mazorxIdx].mazorKitCode
                    ) {
                        dispatch({
                            type: VALIDATE_MAZOR_CODE_RESPONSE,
                            payload: { statusCode: 'draft' },
                        });
                    }
                }
            } else {
                setMazorxChecked(false);
                setMazorRoboticsCode('');
                if (mazorxIdx >= 0) {
                    additionalProcedureData[mazorxIdx].mazorKitCode = '';
                }
                dispatch({
                    type: VALIDATE_MAZOR_CODE_RESPONSE,
                    payload: null,
                });
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        if (
            procedureInfoData &&
            procedureInfoData.additionalProcedure &&
            procedureInfoData.additionalProcedure[0] !==
                'ADDITIONAL_PROCEDURE_DATA'
        ) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const stealthAxisIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'Stealth AXiS'
            );
            if (
                stealthAxisIdx >= 0 &&
                additionalProcedureData[stealthAxisIdx] &&
                additionalProcedureData[stealthAxisIdx].isSelected
            ) {
                setStealthAxisChecked(true);
                if (additionalProcedureData[stealthAxisIdx].stealthAxisCode) {
                    setStealthAxisCode(
                        additionalProcedureData[stealthAxisIdx].stealthAxisCode
                    );
                }
                if (
                    typeof additionalProcedureData[stealthAxisIdx]
                        .stealthAxisAutoPilot === 'boolean'
                ) {
                    setStealthAxisAutoPilot(
                        additionalProcedureData[stealthAxisIdx]
                            .stealthAxisAutoPilot
                    );
                } else {
                    setStealthAxisAutoPilot(null);
                }
                if (
                    typeof additionalProcedureData[stealthAxisIdx]
                        .stealthAxisLiveAlign === 'boolean'
                ) {
                    setStealthAxisLiveAlign(
                        additionalProcedureData[stealthAxisIdx]
                            .stealthAxisLiveAlign
                    );
                } else {
                    setStealthAxisLiveAlign(null);
                }
                if (
                    additionalProcedureData[stealthAxisIdx].stealthCaseCoverage
                ) {
                    const stealthCaseCoverageStr =
                        additionalProcedureData[stealthAxisIdx].stealthCaseCoverage;
                    setStealthAxisCaseCoverageInputValue(stealthCaseCoverageStr);
                    const stealthCaseCoverageObj = {
                        caseCoverageFormattedName: stealthCaseCoverageStr,
                    };
                    setSelectedStealthAxisCaseCoverage(stealthCaseCoverageObj);
                    dispatch(setStealthCaseCoverageValue(stealthCaseCoverageObj));
                }
            } else {
                setStealthAxisChecked(false);
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                if (stealthAxisIdx >= 0) {
                    additionalProcedureData[stealthAxisIdx].stealthAxisCode =
                        '';
                }
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);

    useEffectWithErrorLogging(() => {
        const params = {
            sstRef: myCaseRefId,
        };
        params?.sstRef &&
            params?.sstRef.length > 0 &&
            dispatch(
                getDropdownValues({
                    dropDownName: 'mazorCaseCoverageEmployees',
                    value: params,
                })
            );
    }, [myCaseRefId]);

    const radioButtonChangeHandler = (additionalProcedureData, idx, val) => {
        let modifiedData = [];
        if (
            Object.keys(additionalProcedureData).length > 0 &&
            additionalProcedureData !== 'deformityData'
        ) {
            modifiedData = [...additionalProcedureData];
            modifiedData[idx].isSelected = val;
            if (modifiedData[idx].description === 'Advanced Energy') {
                setAdvancedEnergyCheck(val);
                modifiedData[idx].advancedEnergyProduct &&
                    Object.keys(modifiedData[idx].advancedEnergyProduct).map(
                        (key) => {
                            modifiedData[idx].advancedEnergyProduct[
                                key
                            ] = false;
                        }
                    );
            }
            if (
                modifiedData[idx].isSelected === false &&
                modifiedData[idx].description === 'Advanced Energy'
            ) {
                advanceEnergyProduct &&
                    advanceEnergyProduct.map((item) => {
                        item.isSelected = false;
                    });
            }
            if (modifiedData[idx].description === 'MazorX Robot Used' && !val) {
                dispatch(setMazorCaseCoverageValue(null));
                setMazorCaseCoverageInputValue('');
                setSelectedMazorCaseCoverage('');
                const mazorIdx = modifiedData.findIndex(
                    (x) => x.description === 'MazorX Robot Used' && !val
                );
                const addProcData = [...modifiedData];
                if (mazorIdx >= 0) {
                    addProcData[mazorIdx].mazorCaseCoverage = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }
            if (modifiedData[idx].description === 'Stealth AXiS' && !val) {
                dispatch(setStealthCaseCoverageValue(null));
                setStealthAxisCaseCoverageInputValue('');
                setSelectedStealthAxisCaseCoverage('');
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                setStealthAxisCodeError('');
                const stealthIdx = modifiedData.findIndex(
                    (x) => x.description === 'Stealth AXiS' && !val
                );

                const addProcData = [...modifiedData];
                if (stealthIdx >= 0) {
                    addProcData[stealthIdx].stealthCaseCoverage = null;
                    addProcData[stealthIdx].stealthAxisCode = '';
                    addProcData[stealthIdx].stealthAxisAutoPilot = null;
                    addProcData[stealthIdx].stealthAxisLiveAlign = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }

            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: modifiedData,
            }));
            const modifiedPhysicianFinderData = getModifiedPhysicianFinderData(
                procedureInfoData,
                val,
                modifiedData,
                idx
            );
            if (modifiedPhysicianFinderData) {
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        therapies: modifiedPhysicianFinderData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    therapies: modifiedPhysicianFinderData,
                }));
            }
        } else if (additionalProcedureData === 'deformityData') {
            modifiedData = getModifiedDeformityCorrectionData(
                procedureInfoData,
                idx,
                val
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    technologies: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                technologies: modifiedData,
            }));
        }
    };

    const mazorCodeValidator = (e) => {
        const inputValue = e.target.value;
        const res = inputValue
            .replace(/[^A-Za-z0-9!@#$%^&*()]/g, '')
            .slice(0, 11);

        setMazorRoboticsCode(res);
        const addProcData = [...procedureInfoData.additionalProcedure];
        const mazorxIdx = addProcData.findIndex(
            (x) => x.description === 'MazorX Robot Used' && x.isSelected
        );
        if (mazorxIdx >= 0) {
            addProcData[mazorxIdx].mazorKitCode = res;
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: addProcData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }

        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);
        const isValid11Char = /^[A-Za-z0-9!@#$%^&*()]+$/.test(res);
        const isValidLength =
            (res.length === 7 && isAlphanumericOnly) ||
            (res.length === 11 && isValid11Char);

        if (isValidLength) {
            dispatch(
                validateMazorCodeRequest({
                    mazorKitCode: encodeURIComponent(res),
                })
            );
        } else {
            dispatch({
                type: VALIDATE_MAZOR_CODE_RESPONSE,
                payload: null,
            });
        }
    };
    const stealthCodeValidatorOnBlur = (e) => {
        dispatch({
            type: VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
            payload:
                e.target.value.length < 6
                    ? {
                          statusCode: 'failed',
                          statusDescription: stealthAxisCodeError,
                      }
                    : e.target.value.length === 6
                    ? 'Valid Code'
                    : null,
        });
    };
    const mazorCodeValidatorOnBlur = (e) => {
        const res = e.target.value
            .replace(/[^A-Za-z0-9!@#$%^&*()]/g, '')
            .slice(0, 11);
        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);

        const invalidMessage = t(
            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.mazorXUsed.invalidMsg'
        );

        const getValidationPayload = () => {
            if (res.length === 0) {
                return null;
            }

            if (res.length < 7 || (res.length > 7 && res.length < 11)) {
                return {
                    statusCode: 'failed',
                    statusDescription: invalidMessage,
                };
            }

            if (res.length === 7) {
                return isAlphanumericOnly
                    ? validateMazorCodeRes
                    : {
                          statusCode: 'failed',
                          statusDescription: invalidMessage,
                      };
            }

            if (res.length === 11) {
                return validateMazorCodeRes;
            }

            return null;
        };

        dispatch({
            type: VALIDATE_MAZOR_CODE_RESPONSE,
            payload: getValidationPayload(),
        });
    };

    useEffectWithErrorLogging(() => {
        if (
            Object.keys(
                createProcedureDraftOrderObject(
                    procedureInfoData,
                    advanceEnergyProduct,
                    retractorUsedOtherFieldValue,
                    uivArray,
                    livArray,
                    totalLevelsNumber
                )
            ).length > 0
        ) {
            const reportUsageObj = createProcedureDraftOrderObject(
                procedureInfoData,
                advanceEnergyProduct,
                retractorUsedOtherFieldValue,
                uivArray,
                livArray,
                totalLevelsNumber
            );
            setReportUsageFormObj({
                ...reportUsageFormObj,
                procedure: reportUsageObj,
            });
        }
    }, [advanceEnergyProduct]);

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            retractorUsedOtherFieldValue.length > 0 &&
            getAdditionalTextareaLimit(retractorUsedOtherFieldValue) > 0
        ) {
            setTextAreaCharLimit(
                charCountLimit +
                    getAdditionalTextareaLimit(retractorUsedOtherFieldValue)
            );
        } else {
            setTextAreaCharLimit(charCountLimit);
        }
    }, [retractorUsedOtherFieldValue]);

    useEffectWithErrorLogging(() => {
        if (
            procedureInfoData &&
            Object.keys(procedureInfoData).length > 0 &&
            !showReportPayment
        ) {
            setFooterButtonStatuses(
                footerButtonStatuses.map((x) =>
                    x.btnName !== t('equity.equityFooter.cancelButton') &&
                    x.btnName !== t('equity.equityFooter.saveAndExitButton') &&
                    x.btnName !== submit &&
                    x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable:
                                  !checkIfValidProcedureData(
                                      procedureInfoData,
                                      isErrorFoundInProcedure,
                                      isErrorFoundInFirstLevel,
                                      null,
                                      {
                                          autoPilotVisible: reportUsageStealthAutoPilotVisibility === VISIBLE,
                                          liveAlignVisible: reportUsageStealthLiveAlignVisibility === VISIBLE,
                                      }
                                  ) ||
                                  (procedureDataPhysicianVisibility &&
                                  physicianDropdownZGReportUsageMandatory ===
                                      MANDATORY
                                      ? !selectedPhysicianData?.physicianId
                                      : false) ||
                                  (showProcedureDropdown &&
                                  procedureTypeUsageMandatoryRule === MANDATORY
                                      ? !(
                                            dropDownValue?.procedureCode &&
                                            dropDownValue?.procedureCode
                                                .length > 0
                                        )
                                      : false) ||
                                  (pediatricSurgeryVisibility &&
                                  pediatricMandatoryRule
                                      ? !(
                                            pediatricCheck !== '' &&
                                            pediatricCheck !== undefined
                                        )
                                      : false) ||
                                  (mazorxChecked
                                      ? !(validateMazorCodeRes &&
                                          (validateMazorCodeRes.statusCode ===
                                              '10723' ||
                                              validateMazorCodeRes.statusCode ===
                                                  'draft'))
                                      : false) ||
                                  (physicianTextUsageVisibility === VISIBLE &&
                                  physicianTextUsageMandatory === MANDATORY
                                      ? physicianTextBoxType !== 'unknown' &&
                                        !physicianFieldText
                                      : false),
                          }
                        : x
                )
            );
            const reportUsageObj = { ...reportUsageFormObj };
            if (selectedPhysicianData && selectedPhysicianData.physicianId) {
                reportUsageObj.physicianId = selectedPhysicianData.physicianId;
            }
            if (physicianTextUsageVisibility === VISIBLE) {
                reportUsageObj.physicianFieldText =
                    physicianTextBoxType === 'unknown'
                        ? ''
                        : physicianFieldText || '';
            }
            if (
                pediatricSurgeryVisibility &&
                pediatricCheck !== '' &&
                pediatricCheck !== undefined
            ) {
                reportUsageObj.pediatricSurgery = pediatricCheck;
            }
            if (
                showProcedureDropdown &&
                dropDownValue &&
                dropDownValue?.procedureCode &&
                dropDownValue?.procedureDescription
            ) {
                reportUsageObj.procedureCode = dropDownValue.procedureCode;
                reportUsageObj.procedureDescription =
                    dropDownValue.procedureDescription;
            }

            if (
                Object.keys(
                    createProcedureDraftOrderObject(
                        procedureInfoData,
                        advanceEnergyProduct,
                        retractorUsedOtherFieldValue,
                        uivArray,
                        livArray,
                        totalLevelsNumber
                    )
                ).length > 0
            ) {
                const procedureDraft = createProcedureDraftOrderObject(
                    procedureInfoData,
                    advanceEnergyProduct,
                    retractorUsedOtherFieldValue,
                    uivArray,
                    livArray,
                    totalLevelsNumber
                );
                reportUsageObj.procedure = procedureDraft;
            }
            setReportUsageFormObj(reportUsageObj);
        }
    }, [
        showReportPayment,
        procedureInfoData,
        selectedPhysicianData,
        dropDownValue,
        mazorxChecked,
        validateMazorCodeRes,
        advanceEnergyRes,
        advancedEnergyCheck,
        advEnergyCode,
        retractorUsedOtherFieldValue,
        uivArray,
        livArray,
        totalLevelsNumber,
        currentActivity,
        procedureData,
        isErrorFoundInProcedure,
        isErrorFoundInFirstLevel,
        advanceEnergyProduct,
        pediatricCheck,
        physicianFieldText,
        physicianTextBoxType,
    ]);
    const checkboxSelectionChangeHandler = (e, card, idx, val) => {
        let modifiedData = [];
        if (card === 'additionalProcedureData') {
            let temp = {};
            let energyProd = [...advanceEnergyProduct];
            if (energyProd[idx].description === val) {
                energyProd[idx].isSelected = !energyProd[idx].isSelected;
            }
            setAdvanceEnergyProduct(energyProd);
            let reportUsageObj = { ...reportUsageFormObj };
            temp = reportUsageObj?.procedure?.additionProcedure;
            if (temp) {
                temp.advancedEnergyProduct[val] = energyProd[idx].isSelected;
            }
            reportUsageObj.procedure.additionProcedure = temp;
            setReportUsageFormObj(reportUsageObj);
            if (temp.advancedEnergyProduct) {
                let data = temp.advancedEnergyProduct;
                dispatch({
                    type: SET_ADVANCE_ENERGY_DATA,
                    payload: data,
                });
                setAdvEnergyCode(!advEnergyCode);
            }

            let tempProcedureData = { ...procedureInfoData };
            let ind = tempProcedureData.additionalProcedure.findIndex(
                (it) => it.description === 'Advanced Energy'
            );
            let procAdditionalData = tempProcedureData.additionalProcedure;
            procAdditionalData[ind].advancedEnergyProduct =
                temp.advancedEnergyProduct;

            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    additionalProcedure: procAdditionalData,
                })
            );
            // setProcedureInfoData((prevState) => ({
            //     ...prevState,
            //     additionalProcedure: modifiedData,
            // }));
        } else if (card === 'physicianFinder') {
            modifiedData = getModifiedPhysicianFinderDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    therapies: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                therapies: modifiedData,
            }));
            const modifiedAdditionalProcedureData =
                getModifiedAdditionalProcedureData(
                    procedureInfoData,
                    val,
                    e.target.checked
                );
            if (modifiedAdditionalProcedureData) {
                dispatch(
                    setProcedureData({
                        ...procedureInfoData,
                        additionalProcedure: modifiedAdditionalProcedureData,
                    })
                );
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: modifiedAdditionalProcedureData,
                }));
            }
        } else if (card === 'retractorsUsed') {
            if (
                (val === 'Other' && !e.target.checked) ||
                (val === 'None' && e.target.checked)
            ) {
                dispatch(setRetractorUsedOtherField(''));
            }
            modifiedData = getModifiedRetractorUsedOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    retractors: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                retractors: modifiedData,
            }));
        } else if (card === 'biologicsUsed') {
            modifiedData = getModifiedBiologicsUsedDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            const medtronicOrCompetitve = modifiedData.filter(
                (x) => x.isSelected && x.code === '02'
            );
            const isNoneChecked =
                modifiedData.filter((x) => x.isSelected && x.code === '01')
                    ?.length > 0;
            if (medtronicOrCompetitve.length > 0) {
                setshowBiologisDetails(true);
            } else {
                setshowBiologisDetails(false);
            }
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    biologicsUsed: modifiedData,
                    biologicsDetail:
                        isNoneChecked || medtronicOrCompetitve.length === 0
                            ? procedureInfoData.biologicsDetail?.map(
                                  (item) => ({
                                      ...item,
                                      isMedtronicSelected: null,
                                      isCompetitiveSelected: null,
                                  })
                              )
                            : procedureInfoData.biologicsDetail,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsUsed: modifiedData,
                biologicsDetail:
                    isNoneChecked || medtronicOrCompetitve.length === 0
                        ? procedureInfoData.biologicsDetail?.map((item) => ({
                              ...item,
                              isMedtronicSelected: null,
                              isCompetitiveSelected: null,
                          }))
                        : prevState.biologicsDetail,
            }));
        } else if (
            card === 'biologicsDetailMedtronic' ||
            card === 'biologicsDetailCompetitive'
        ) {
            modifiedData = [...procedureInfoData.biologicsDetail];
            modifiedData[idx][
                card === 'biologicsDetailMedtronic'
                    ? 'isMedtronicSelected'
                    : 'isCompetitiveSelected'
            ] = e.target.checked;
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    biologicsDetail: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsDetail: modifiedData,
            }));
        }
    };

    const handleInputChange = (name, value) => {
        let object = {
            [name]: value,
        };
        if (value.length > charCountLimit) {
            const sliceLastIdx = charCountLimit - value.length;
            value = value.slice(0, sliceLastIdx);
        }
        dispatch(setRetractorUsedOtherField(value));
    };

    const checkboxReportPaymentClickHandler = (e, item, index) => {
        const modifiedGridData = [...reportPaymentGridData];
        let selectedIdx = null;
        if (item.quantity) {
            selectedIdx = modifiedGridData.findIndex(
                (x, itemIndex) =>
                    x.productCFN === item.productCFN &&
                    item.quantity === x.bundleItem.quantity &&
                    itemIndex === index
            );
        } else {
            selectedIdx = modifiedGridData.findIndex(
                (x, itemIndex) =>
                    x.productCFN === item.productCFN &&
                    (item?.otherQuantity
                        ? x.otherQuantity === item.otherQuantity
                        : x.usedQuantity === item.usedQuantity) &&
                    itemIndex === index
            );
        }
        if (selectedIdx >= 0) {
            modifiedGridData[selectedIdx].isSelected = e.target.checked;
            setReportPaymentGridData(modifiedGridData);
            setCheckBoxSelectedIndex(selectedIdx);
            setSelectedCheckBox(
                modifiedGridData.filter(
                    (item) =>
                        item.isSelected &&
                        item.salesOrg != '' &&
                        item?.unitPrice
                )
            );
        }
    };
    const handlePoApplyClick = (podetails) => {
        let modifiedGridData = [...reportPaymentGridData];
        podetails.map((details) => {
            let valuefound = false;
            modifiedGridData.map((item, index) => {
                if (
                    !valuefound &&
                    item.isSelected &&
                    details.productCFN === item.productCFN &&
                    (details?.otherQuantity
                        ? details.otherQuantity === item.otherQuantity
                        : details.usedQuantity === item.usedQuantity)
                ) {
                    modifiedGridData[index] = {
                        ...details,
                        isSelected: false,
                    };
                    valuefound = true;
                }
            });
        });
        setSelectedCheckBox([]);
        setReportPaymentGridData(modifiedGridData);
        // setRpInitialLoad(true);
        setAllSelected(false);
    };
    const handleRemoveAllPO = () => {
        if (selectedCheckBox.length >= 1) {
            let modifiedGridData = [...reportPaymentGridData];
            selectedCheckBox.map((details) => {
                modifiedGridData.map((item, index) => {
                    if (
                        details.productCFN === item.productCFN &&
                        (details?.otherQuantity
                            ? details.otherQuantity === item.otherQuantity
                            : details.usedQuantity === item.usedQuantity)
                    ) {
                        if (myCaseResourceType === 'reportPayment') {
                            modifiedGridData[index] = {
                                ...item,
                                isPoImageError: true,
                                poImageErrorMsg: t(
                                    'productValidationMessages.poInfoRequired'
                                ),
                                payment: '',
                                isSelected: false,
                            };
                        } else {
                            modifiedGridData[index] = {
                                ...item,
                                isPoImageError: false,
                                poImageErrorMsg: '',
                                payment: '',
                                isSelected: false,
                            };
                        }
                    }
                });
            });
            // setRpInitialLoad(true);
            setSelectedCheckBox([]);
            setReportPaymentGridData(modifiedGridData);
            setAllSelected(false);
        }
    };
    const removeSinglePoItem = (details, itemIndex) => {
        let modifiedGridData = [...reportPaymentGridData];
        modifiedGridData.map((item, index) => {
            if (
                index === itemIndex &&
                details.productCFN === item.productCFN &&
                (details?.otherQuantity
                    ? details.otherQuantity === item.otherQuantity
                    : details.usedQuantity === item.usedQuantity)
            ) {
                if (myCaseResourceType === 'reportPayment') {
                    modifiedGridData[index] = {
                        ...item,
                        payment: '',
                        isPoImageError: true,
                        poImageErrorMsg: t(
                            'productValidationMessages.poInfoRequired'
                        ),
                    };
                } else {
                    modifiedGridData[index] = {
                        ...item,
                        payment: '',
                        isPoImageError: false,
                        poImageErrorMsg: '',
                    };
                }

                return;
            }
        });
        setReportPaymentGridData(modifiedGridData);
    };
    const handleAllCheckBoxSelect = (e) => {
        const value = e.target.checked;
        const modifiedGridData = [...reportPaymentGridData];
        if (modifiedGridData.length >= 1) {
            modifiedGridData.map((item, index) => {
                if (item.salesOrg && item.salesOrg != '' && item?.unitPrice) {
                    if (
                        myCaseResourceType === 'reportPayment' &&
                        !item.isDeleteButtonPresent &&
                        !item.isAdditionalCartEntry
                    ) {
                        modifiedGridData[index].isSelected = false;
                    } else {
                        modifiedGridData[index].isSelected = value;
                    }
                } else {
                    modifiedGridData[index].isSelected = false;
                }
            });
        }
        setAllSelected(value);
        setReportPaymentGridData(modifiedGridData);
        let test = modifiedGridData.filter((item) => {
            const isCheckReportPayment =
                item.isDeleteButtonPresent || item.isAdditionalCartEntry;

            return myCaseResourceType === 'reportPayment'
                ? isCheckReportPayment &&
                      item.isSelected &&
                      item.salesOrg &&
                      item.salesOrg != '' &&
                      item?.unitPrice
                : true &&
                      item.isSelected &&
                      item.salesOrg &&
                      item.salesOrg != '' &&
                      item?.unitPrice;
        });
        setSelectedCheckBox(test);
    };

    const checkRemovePoText = (selectedCheckBox) => {
        const getSelectedCheckBoxIds =
            selectedCheckBox.length > 0
                ? selectedCheckBox.reduce(
                      (acc, currentValue) => acc.concat(currentValue.cfn),
                      []
                  )
                : [];

        let checkPayment = [];

        if (getSelectedCheckBoxIds.length > 0) {
            checkPayment =
                reportPaymentGridData.length > 0
                    ? reportPaymentGridData.filter(
                          (x) =>
                              x?.isSelected &&
                              getSelectedCheckBoxIds.includes(x.cfn) &&
                              x?.payment &&
                              Object.keys(x.payment).length > 0 &&
                              x?.payment?.poNumber
                      )
                    : [];
        }
        return checkPayment.length > 0 ? true : false;
    };

    return (
        <>
            {showReportPayment ? (
                <ReportPayment
                    countryCode={countryCode}
                    reportPaymentGridData={reportPaymentGridData}
                    setReportPaymentGridData={setReportPaymentGridData}
                    checkboxReportPaymentClickHandler={
                        checkboxReportPaymentClickHandler
                    }
                    headerReportPaymentCheckboxClickHandler={
                        handleAllCheckBoxSelect
                    }
                    priceOverrideReportUsageVisibility={
                        priceOverrideReportUsageVisibility
                    }
                    allSelected={allSelected}
                    setAllSelected={setAllSelected}
                    selectedCheckBox={selectedCheckBox}
                    checkBoxSelectedIndex={checkBoxSelectedIndex}
                    onPoApplyClick={handlePoApplyClick}
                    enablePObutton={selectedCheckBox.length > 0 ? true : false}
                    showRemovePOText={checkRemovePoText(selectedCheckBox)}
                    removeAllPo={handleRemoveAllPO}
                    deletePO={removeSinglePoItem}
                    showReportPayment={showReportPayment}
                    setSelectedCheckBox={setSelectedCheckBox}
                    myCaseResourceType={myCaseResourceType}
                    rpInitialLoad={rpInitialLoad}
                    setRpInitialLoad={setRpInitialLoad}
                    vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                    // initialGridData={initialGridData}
                    onFlagChange={onFlagChange}
                    isPriceOverride={isPriceOverride}
                    setPriceOverride={setPriceOverride}
                    isRPPriceOverride={isRPPriceOverride}
                    setRPPriceOverride={setRPPriceOverride}
                    setRPPriceOverrideData={setRPPriceOverrideData}
                    priceOverrideReason={priceOverrideReason}
                    setPriceOverrideReason={setPriceOverrideReason}
                    setShipAddress={setShipAddress}
                    shipAddress={shipAddress}
                    navigateToSpecifiedRPScreen={navigateToSpecifiedRPScreen}
                    pricingNotes={pricingNotes}
                    setPricingNotes={setPricingNotes}
                    setIsReportPaymentScreen={setIsReportPaymentScreen}
                    currentActivity={currentActivity}
                    setViewSurgeryNotes={setViewSurgeryNotes}
                    priceOverrideReasonMandatoryUsage={
                        priceOverrideReasonMandatoryUsage
                    }
                    priceOverrideReasonVisibilityUsage={
                        priceOverrideReasonVisibilityUsage
                    }
                    priceOverrideCommentsMandatoryUsage={
                        priceOverrideCommentsMandatoryUsage
                    }
                    priceOverrideCommentsVisibilityUsage={
                        priceOverrideCommentsVisibilityUsage
                    }
                    setPriceOverrideTableData={setPriceOverrideTableData}
                    priceOverrideTableData={priceOverrideTableData}
                />
            ) : (
                !showReportPayment &&
                currentActivity !== 'Record' &&
                currentActivity !== 'Replen' &&
                currentActivity !== 'Submit' &&
                currentActivity !== undefined && (
                    <ProcedureViewContainer
                        procedureData={procedureData}
                        procedureInfoData={procedureInfoData}
                        progressBarClicked={progressBarClicked}
                        setProcedureInfoData={setProcedureInfoData}
                        radioButtonChangeHandler={radioButtonChangeHandler}
                        mazorxChecked={mazorxChecked}
                        advancedEnergyCheck={advancedEnergyCheck}
                        advanceEnergyProduct={advanceEnergyProduct}
                        mazorRoboticsCode={mazorRoboticsCode}
                        mazorCodeValidator={mazorCodeValidator}
                        validateMazorCodeRes={validateMazorCodeRes}
                        mazorCodeValidatorOnBlur={mazorCodeValidatorOnBlur}
                        checkboxSelectionChangeHandler={
                            checkboxSelectionChangeHandler
                        }
                        setDropDownValue={setDropDownValue}
                        handleInputChange={handleInputChange}
                        retractorUsedOtherFieldValue={
                            retractorUsedOtherFieldValue
                        }
                        dropDownValue={dropDownValue}
                        showBiologisDetails={showBiologisDetails}
                        setshowReportPayment={setshowReportPayment}
                        proceduresList={proceduresList}
                        selectedPhysicianData={selectedPhysicianData}
                        setSelectedPhysicianData={setSelectedPhysicianData}
                        setPhysicianInputValue={setPhysicianInputValue}
                        physicianInputValue={physicianInputValue}
                        setMazorCaseCoverageInputValue={
                            setMazorCaseCoverageInputValue
                        }
                        mazorCaseCoverageInputValue={
                            mazorCaseCoverageInputValue
                        }
                        setSelectedMazorCaseCoverage={
                            setSelectedMazorCaseCoverage
                        }
                        selectedMazorCaseCoverage={selectedMazorCaseCoverage}
                        showProcedureDropdown={showProcedureDropdown}
                        countryCode={countryCode}
                        textAreaCharLimit={textAreaCharLimit}
                        charCountLimit={charCountLimit}
                        procedureValue={{
                            procedureCode: usageDetails?.procedureCode,
                            procedureDescription:
                                usageDetails?.procedureDescription,
                        }}
                        reportUsageObject={reportUsageObject}
                        isProcedureReqConfig={
                            usageDetails?.isProcedureReqConfig
                        }
                        isDraft={isDraft && usageDetails?.isProcedureReq}
                        procedureDataPhysicianVisibility={
                            procedureDataPhysicianVisibility
                        }
                        procedureMandatoryRule={
                            procedureTypeUsageMandatoryRule === MANDATORY
                        }
                        isDisabledPediatric={isDisabledPediatric}
                        setPediatricCheck={setPediatricCheck}
                        isPediatricSurgery={isPediatricSurgery}
                        isFromProcedure={true}
                        isReportUsageFlow={true}
                        pediatricSurgeryVisibility={pediatricSurgeryVisibility}
                        pediatricMandatoryRule={pediatricMandatoryRule}
                        pediatricValue={pediatricCheck}
                        stealthAxisChecked={stealthAxisChecked}
                        stealthAxisCode={stealthAxisCode}
                        setStealthAxisCode={setStealthAxisCode}
                        stealthAxisAutoPilot={stealthAxisAutoPilot}
                        setStealthAxisAutoPilot={setStealthAxisAutoPilot}
                        stealthAxisLiveAlign={stealthAxisLiveAlign}
                        setStealthAxisLiveAlign={setStealthAxisLiveAlign}
                        setStealthAxisCaseCoverageInputValue={
                            setStealthAxisCaseCoverageInputValue
                        }
                        stealthAxisCaseCoverageInputValue={
                            stealthAxisCaseCoverageInputValue
                        }
                        setSelectedStealthAxisCaseCoverage={
                            setSelectedStealthAxisCaseCoverage
                        }
                        selectedStealthAxisCaseCoverage={
                            selectedStealthAxisCaseCoverage
                        }
                        stealthCodeValidatorOnBlur={stealthCodeValidatorOnBlur}
                        stealthAxisCodeError={stealthAxisCodeError}
                        setStealthAxisCodeError={setStealthAxisCodeError}
                        reportUsageStealthLiveAlignVisibility={
                            reportUsageStealthLiveAlignVisibility
                        }
                        reportUsageStealthAutoPilotVisibility={
                            reportUsageStealthAutoPilotVisibility
                        }
                        physicianFieldText={physicianFieldText}
                        setPhysicianFieldText={setPhysicianFieldText}
                        physicianTextBoxType={physicianTextBoxType}
                        setPhysicianTextBoxType={setPhysicianTextBoxType}
                    />
                )
            )}
        </>
    );
};

export default ProcedureScreen;
